import EzUtils from "../../utils/EzUtils";
import StorageUtil from "../../utils/StorageUtil";
import { LoanStatus } from "../../utils/LoanStatusDetails";
import {Constants} from "../../components/Constants";
import EzLoanUtil from "@/utils/EzLoanUtil";

const LOAN_SCOPE_DATA = "loanScopeData";

const MERCHANT = "MERCHANT";
const LENDER_CO_BRANDING_DATA = "lenderCoBrandingData";

export default {

  clearLoanScopeData() {
    StorageUtil.removeItem(LOAN_SCOPE_DATA);
    this.clearLenderCoBrandingData();
  },

  setLoanScopeData(loanScopeData) {
    StorageUtil.setItem(LOAN_SCOPE_DATA, JSON.stringify(loanScopeData));
  },

  getLoanScopeData() {
    const loanScopeData = EzUtils.convertToJSONObjectIfString(
      StorageUtil.getItem(LOAN_SCOPE_DATA)
    );
    return loanScopeData ? loanScopeData : {};
  },

  setDetailsFromEzLoan(ezLoan) {
    ezLoan = ezLoan ? ezLoan : {};
    const loan = ezLoan.loan ? ezLoan.loan : {};
    const loanDetails = ezLoan.loanDetails ? ezLoan.loanDetails : {};

    const fundId = EzUtils.isValidId(loan.fundId) ? loan.fundId : -1;
    const loanStatus = loan.status ? loan.status.value : "";
    this.setLoanId(loan.id);
    this.setLoanAccountNumber(loan.accountNo);
    this.setClientId(loan.clientId);
    this.setFundId(fundId);
    this.setName(loan.clientName);
    this.setLoanAmount(loan.principal);
    this.setLoanOfficeId(loan.officeId);
    this.setLoanStatus(loanStatus);

    this.setDetailsFromLoanDetails(loanDetails);

    this.setParentLoanId(EzLoanUtil.getParentLoanId(ezLoan));
  },

  setDetailsFromLoanDetails(loanDetails) {
    loanDetails = loanDetails ? loanDetails : {};

    const mobile = loanDetails.contact ? loanDetails.contact : "";
    const category = loanDetails.category ? loanDetails.category : "";
    const brand = loanDetails.brand ? loanDetails.brand : "";
    const model = loanDetails.model ? loanDetails.model : "";
    const price = loanDetails.price ? loanDetails.price : "0.00";
    const redirectUrl = loanDetails.redirect_url ? loanDetails.redirect_url : "";
    const leadEntity = loanDetails.lead_entity ? loanDetails.lead_entity : "";
    const leadId = EzUtils.isValidId(loanDetails.lead_id) ? loanDetails.lead_id : -1;
    const retailerShortName = loanDetails.retailer_short_name
      ? loanDetails.retailer_short_name
      : "";
    const loanCreationIdentifier = loanDetails.loan_creation_identifier
      ? loanDetails.loan_creation_identifier : "";
    this.setMobile(mobile);
    this.setProductCategory(category);
    this.setBrand(brand);
    this.setModel(model);
    this.setPhonePrice(price);
    this.setLeadId(leadId);
    this.setRedirectUrl(redirectUrl);
    this.setLeadEntity(leadEntity);
    this.setRetailerShortName(retailerShortName);
    this.setLoanCreationIdentifier(loanCreationIdentifier);
  },

  setLoanId(loanId) {
    let loanScopeData = this.getLoanScopeData();
    loanScopeData.loanId = loanId;
    this.setLoanScopeData(loanScopeData);
  },

  getLoanId() {
    let loanScopeData = this.getLoanScopeData();
    return EzUtils.isValidId(loanScopeData.loanId) ? loanScopeData.loanId : -1;
  },

  setClientId(clientId) {
    let loanScopeData = this.getLoanScopeData();
    loanScopeData.clientId = clientId;
    this.setLoanScopeData(loanScopeData);
  },

  getClientId() {
    let loanScopeData = this.getLoanScopeData();
    return EzUtils.isValidId(loanScopeData.clientId) ? loanScopeData.clientId : -1;
  },

  doesClientExist() {
    return EzUtils.isValidId(this.getClientId());
  },

  setFundId(fundId) {
    let loanScopeData = this.getLoanScopeData();
    loanScopeData.fundId = fundId;
    this.setLoanScopeData(loanScopeData);
  },

  getFundId() {
    let loanScopeData = this.getLoanScopeData();
    return EzUtils.isValidId(loanScopeData.fundId) ? loanScopeData.fundId : -1;
  },

  setLoanOfficeId(loanOfficeId) {
    let loanScopeData = this.getLoanScopeData();
    loanScopeData.loanOfficeId = loanOfficeId;
    this.setLoanScopeData(loanScopeData);
  },

  getLoanOfficeId() {
    let loanScopeData = this.getLoanScopeData();
    return EzUtils.isValidId(loanScopeData.loanOfficeId) ? loanScopeData.loanOfficeId : -1;
  },

  setLeadDetails(leadDetails) {
    let loanScopeData = this.getLoanScopeData();
    loanScopeData.leadDetails = leadDetails;
    this.setLoanScopeData(loanScopeData);
  },

  getLeadDetails() {
    let loanScopeData = this.getLoanScopeData();
    return loanScopeData.leadDetails;
  },

  setMobile(mobile) {
    let loanScopeData = this.getLoanScopeData();
    loanScopeData.mobile = mobile;
    this.setLoanScopeData(loanScopeData);
  },

  getMobile() {
    let loanScopeData = this.getLoanScopeData();
    return EzUtils.isValidString(loanScopeData.mobile) ? loanScopeData.mobile : "";
  },

  setPhoneCode(phoneCode) {
    let loanScopeData = this.getLoanScopeData();
    loanScopeData.phoneCode = phoneCode;
    this.setLoanScopeData(loanScopeData);
  },

  getPhoneCode() {
    let loanScopeData = this.getLoanScopeData();
    return loanScopeData.phoneCode;
  },

  setApplicantType(applicantType) {
    let loanScopeData = this.getLoanScopeData();
    loanScopeData.applicantType = applicantType;
    this.setLoanScopeData(loanScopeData);
  },

  getApplicantType() {
    let loanScopeData = this.getLoanScopeData();
    return loanScopeData.applicantType ? loanScopeData.applicantType : "";
  },

  setCompanyType(companyType) {
    let loanScopeData = this.getLoanScopeData();
    loanScopeData.companyType = companyType;
    this.setLoanScopeData(loanScopeData);
  },

  getCompanyType() {
    let loanScopeData = this.getLoanScopeData();
    return loanScopeData.companyType ? loanScopeData.companyType : "";
  },

  setRelationWithApplicant(relationWithApplicant) {
    let loanScopeData = this.getLoanScopeData();
    loanScopeData.relationWithApplicant = relationWithApplicant;
    this.setLoanScopeData(loanScopeData);
  },

  getRelationWithApplicant() {
    let loanScopeData = this.getLoanScopeData();
    return loanScopeData.relationWithApplicant ? loanScopeData.relationWithApplicant : "";
  },

  setLoanCreationIdentifier(loanCreationIdentifier) {
    let loanScopeData = this.getLoanScopeData();
    loanScopeData.loanCreationIdentifier = loanCreationIdentifier;
    this.setLoanScopeData(loanScopeData);
  },

  getLoanCreationIdentifier() {
    let loanScopeData = this.getLoanScopeData();
    return loanScopeData.loanCreationIdentifier
        ? loanScopeData.loanCreationIdentifier : "";
  },

  setLoanAccountNumber(loanAccountNumber) {
    let loanScopeData = this.getLoanScopeData();
    loanScopeData.loanAccountNumber = loanAccountNumber;
    this.setLoanScopeData(loanScopeData);
  },

  getLoanAccountNumber() {
    let loanScopeData = this.getLoanScopeData();
    return EzUtils.isValidString(loanScopeData.loanAccountNumber) ? loanScopeData.loanAccountNumber
      : "";
  },

  setProductCategory(productCategory) {
    let loanScopeData = this.getLoanScopeData();
    loanScopeData.productCategory = productCategory;
    this.setLoanScopeData(loanScopeData);
  },

  getProductCategory() {
    let loanScopeData = this.getLoanScopeData();
    return EzUtils.isValidString(loanScopeData.productCategory) ? loanScopeData.productCategory
      : "";
  },

  setBrand(brand) {
    let loanScopeData = this.getLoanScopeData();
    loanScopeData.brand = brand;
    this.setLoanScopeData(loanScopeData);
  },

  getBrand() {
    let loanScopeData = this.getLoanScopeData();
    return EzUtils.isValidString(loanScopeData.brand) ? loanScopeData.brand : "";
  },

  setModel(model) {
    let loanScopeData = this.getLoanScopeData();
    loanScopeData.model = model;
    this.setLoanScopeData(loanScopeData);
  },

  getModel() {
    let loanScopeData = this.getLoanScopeData();
    return EzUtils.isValidString(loanScopeData.model) ? loanScopeData.model : "";
  },

  setName(name) {
    let loanScopeData = this.getLoanScopeData();
    loanScopeData.name = name;
    this.setLoanScopeData(loanScopeData);
  },

  setWebViewSecretKey(secretKey) {
    let loanScopeData = this.getLoanScopeData();
    loanScopeData.webViewSecretKey = secretKey;
    this.setLoanScopeData(loanScopeData);
  },

  getWebViewSecretKey() {
    let loanScopeData = this.getLoanScopeData();
    return EzUtils.isValidString(loanScopeData.webViewSecretKey) ? loanScopeData.webViewSecretKey
      : "";
  },

  getName() {
    let loanScopeData = this.getLoanScopeData();
    return EzUtils.isValidString(loanScopeData.name) ? loanScopeData.name : "";
  },

  setPhonePrice(phonePrice) {
    let loanScopeData = this.getLoanScopeData();
    loanScopeData.phonePrice = phonePrice.toString();
    this.setLoanScopeData(loanScopeData);
  },

  getPhonePrice() {
    let loanScopeData = this.getLoanScopeData();
    return EzUtils.isValidString(loanScopeData.phonePrice) ? loanScopeData.phonePrice : "0.00";
  },

  setLoanAmount(loanAmount) {
    let loanScopeData = this.getLoanScopeData();
    loanScopeData.loanAmount = loanAmount.toString();
    this.setLoanScopeData(loanScopeData);
  },

  getLoanAmount() {
    let loanScopeData = this.getLoanScopeData();
    return EzUtils.isValidString(loanScopeData.loanAmount) ? loanScopeData.loanAmount : "0.00";
  },

  setRedirectUrl(redirectUrl) {
    let loanScopeData = this.getLoanScopeData();
    loanScopeData.redirectUrl = redirectUrl;
    this.setLoanScopeData(loanScopeData);
  },

  getRedirectUrl() {
    let loanScopeData = this.getLoanScopeData();
    return loanScopeData.redirectUrl;
  },

  setLeadEntity(leadEntity) {
    let loanScopeData = this.getLoanScopeData();
    loanScopeData.leadEntity = leadEntity;
    this.setLoanScopeData(loanScopeData);
  },

  getLeadEntity() {
    let loanScopeData = this.getLoanScopeData();
    return loanScopeData.leadEntity;
  },

  //Merchant on boarding
  isOnboardingLoan() {
    if(this.getProductCategory()){
      let productCategory = EzUtils.removeUnderscoreFromString(this.getProductCategory());
      return EzUtils.areEqualString(Constants.DEALER_ONBOARDING, productCategory, true);
    }else{
      return EzUtils.areEqualString(MERCHANT, this.getLeadEntity(), true);
    }
  },

  setLoanStatus(loanStatus) {
    let loanScopeData = this.getLoanScopeData();
    loanScopeData.loanStatus = loanStatus;
    this.setLoanScopeData(loanScopeData);
  },

  getLoanStatus() {
    let loanScopeData = this.getLoanScopeData();
    return loanScopeData.loanStatus;
  },

  isLoanRejected() {
    return EzUtils.areEqualString(LoanStatus.REJECTED, this.getLoanStatus(), true);
  },

  isLoanWithdrawnByApplicant() {
    return EzUtils.areEqualString(LoanStatus.WITHDRAWN_BY_APPLICANT, this.getLoanStatus(), true);
  },

  isLoanApproved() {
    return EzUtils.areEqualString(LoanStatus.APPROVED, this.getLoanStatus(), true);
  },

  isLoanActive() {
    return EzUtils.areEqualString(LoanStatus.ACTIVE, this.getLoanStatus(), true);
  },

  isLoanPending() {
    return this.isLoanSubmittedAndPendingApproval() || this.isLoanSubmittedToFund();
  },

  isLoanSubmittedAndPendingApproval() {
    return EzUtils.areEqualString(
      LoanStatus.SUBMITTED_AND_PENDING_APPROVAL,
      this.getLoanStatus(),
      true
    );
  },

  isLoanSubmittedToFund() {
    return EzUtils.areEqualString(LoanStatus.SUBMITTED_TO_FUND, this.getLoanStatus(), true);
  },

  setCurrentLoanTask(currentLoanTask) {
    let loanScopeData = this.getLoanScopeData();
    loanScopeData.currentLoanTask = currentLoanTask;
    this.setLoanScopeData(loanScopeData);
  },

  getCurrentLoanTask() {
    let loanScopeData = this.getLoanScopeData();
    return loanScopeData.currentLoanTask;
  },

  setChosenEmiScheme(chosenEmiScheme) {
    let loanScopeData = this.getLoanScopeData();
    loanScopeData.chosenEmiScheme = chosenEmiScheme;
    this.setLoanScopeData(loanScopeData);
  },

  getChosenEmiScheme() {
    let loanScopeData = this.getLoanScopeData();
    return loanScopeData.chosenEmiScheme;
  },

  setPerfiosPayload(perfiosPayload) {
    let loanScopeData = this.getLoanScopeData();
    loanScopeData.perfiosPayload = perfiosPayload;
    this.setLoanScopeData(loanScopeData);
  },

  getPerfiosPayload() {
    let loanScopeData = this.getLoanScopeData();
    return loanScopeData.perfiosPayload;
  },

  setEsignConfiguration(esignConfiguration) {
    let loanScopeData = this.getLoanScopeData();
    loanScopeData.esignConfiguration = esignConfiguration;
    this.setLoanScopeData(loanScopeData);
  },

  getEsignConfiguration() {
    let loanScopeData = this.getLoanScopeData();
    return loanScopeData.esignConfiguration;
  },

  setLeadId(leadId) {
    let loanScopeData = this.getLoanScopeData();
    loanScopeData.leadId = leadId;
    this.setLoanScopeData(loanScopeData);
  },

  getLeadId() {
    let loanScopeData = this.getLoanScopeData();
    return EzUtils.isValidId(loanScopeData.leadId) ? loanScopeData.leadId : -1;
  },

  setRetailerShortName(retailerShortName) {
    let loanScopeData = this.getLoanScopeData();
    loanScopeData.retailerShortName = retailerShortName;
    this.setLoanScopeData(loanScopeData);
  },

  getRetailerShortName() {
    let loanScopeData = this.getLoanScopeData();
    return loanScopeData.retailerShortName;
  },

  setWaiting(waiting) {
    let loanScopeData = this.getLoanScopeData();
    loanScopeData.waiting = waiting;
    this.setLoanScopeData(loanScopeData);
  },

  isWaiting() {
    let loanScopeData = this.getLoanScopeData();
    return loanScopeData.waiting;
  },

  setMerchantID(merchantID) {
    let loanScopeData = this.getLoanScopeData();
    loanScopeData.merchantID = merchantID;
    this.setLoanScopeData(loanScopeData);
  },

  getMerchantID() {
    let loanScopeData = this.getLoanScopeData();
    return loanScopeData.merchantID;
  },

  setFillClientDetailsWithLeadData(fillClientDetailsWithLeadData) {
    let loanScopeData = this.getLoanScopeData();
    loanScopeData.fillClientDetailsWithLeadData = fillClientDetailsWithLeadData;
    this.setLoanScopeData(loanScopeData);
  },

  fillClientDetailsWithLeadData() {
    let loanScopeData = this.getLoanScopeData();
    return loanScopeData.fillClientDetailsWithLeadData;
  },

  setResendSigningDocumentTryCount(resendSigningDocumentTryCount) {
    const loanScopeData = this.getLoanScopeData();
    loanScopeData.resendSigningDocumentTryCount = resendSigningDocumentTryCount;
    this.setLoanScopeData(loanScopeData);
  },

  getResendSigningDocumentTryCount() {
    const loanScopeData = this.getLoanScopeData();
    return loanScopeData.resendSigningDocumentTryCount
      ? loanScopeData.resendSigningDocumentTryCount
      : 0;
  },

  setFetchingLoanDetailsFirstTime(fetchingLoanDetailsFirstTime) {
    const loanScopeData = this.getLoanScopeData();
    loanScopeData.fetchingLoanDetailsFirstTime = fetchingLoanDetailsFirstTime;
    this.setLoanScopeData(loanScopeData);
  },

  isFetchingLoanDetailsFirstTime() {
    const loanScopeData = this.getLoanScopeData();
    return loanScopeData.fetchingLoanDetailsFirstTime;
  },

  setConsentAccepted(consentAccepted) {
    const loanScopeData = this.getLoanScopeData();
    loanScopeData.consentAccepted = consentAccepted;
    this.setLoanScopeData(loanScopeData);
  },

  isConsentAccepted() {
    const loanScopeData = this.getLoanScopeData();
    return loanScopeData.consentAccepted;
  },

  setConsentAcceptedTimestamp(consentAcceptedTimestamp) {
    const loanScopeData = this.getLoanScopeData();
    loanScopeData.consentAcceptedTimestamp = consentAcceptedTimestamp;
    this.setLoanScopeData(loanScopeData);
  },

  getConsentAcceptedTimestamp() {
    const loanScopeData = this.getLoanScopeData();
    return loanScopeData.consentAcceptedTimestamp;
  },

  setConsentAcceptedOTP(consentAcceptedOTP) {
    const loanScopeData = this.getLoanScopeData();
    loanScopeData.consentAcceptedOTP = consentAcceptedOTP;
    this.setLoanScopeData(loanScopeData);
  },

  getConsentAcceptedOTP() {
    const loanScopeData = this.getLoanScopeData();
    return loanScopeData.consentAcceptedOTP;
  },

  setConsentAcceptedIPAddress(consentAcceptedIp) {
    const loanScopeData = this.getLoanScopeData();
    loanScopeData.consentAcceptedIp = consentAcceptedIp;
    this.setLoanScopeData(loanScopeData);
  },

  getConsentAcceptedIPAddress() {
    const loanScopeData = this.getLoanScopeData();
    return loanScopeData.consentAcceptedIp;
  },

  //TODO remove this code after task type refactoring
  setAllowedTasks(allowedTasks) {
    let loanScopeData = this.getLoanScopeData();
    loanScopeData.allowedTasks = allowedTasks;
    this.setLoanScopeData(loanScopeData);
  },

  getAllowedTasks() {
    let loanScopeData = this.getLoanScopeData();
    return loanScopeData.allowedTasks;
  },
  //TODO remove this code after task type refactoring Till Here

  clearLenderCoBrandingData() {
    StorageUtil.removeItem(LENDER_CO_BRANDING_DATA);
  },

  setLenderCoBrandingData(lenderConfigData) {
    if (lenderConfigData) {
      StorageUtil.setItem(
          LENDER_CO_BRANDING_DATA,
          JSON.stringify(lenderConfigData)
      );
    }
  },

  getLenderCoBrandingData() {
    const lenderConfigData = EzUtils.convertToJSONObjectIfString(
        StorageUtil.getItem(LENDER_CO_BRANDING_DATA)
    );
    return lenderConfigData ? lenderConfigData : {};
  },

  getCobrandingIconText() {
    const lenderConfigData = this.getLenderCoBrandingData();
    return lenderConfigData.cobrandingIconText;
  },

  getCobrandingIcon() {
    const lenderConfigData = this.getLenderCoBrandingData();
    return lenderConfigData.cobrandingIconUrl;
  },

  getSurrogateToCobrandingPresentStages() {
    const lenderConfigData = this.getLenderCoBrandingData();
    return lenderConfigData.surrogateToCobrandingPresentStages;
  },

  getCoBrandingLenderName() {
    const lenderConfigData = this.getLenderCoBrandingData();
    return lenderConfigData.lenderName;
  },

  showLenderCobranding() {
    const lenderConfigData = this.getLenderCoBrandingData();
    return lenderConfigData.showLenderCobranding;
  },

  getLeadEmiSchemeIds(){
    let leadDetails = this.getLeadDetails();
    return leadDetails && leadDetails.emi_scheme_ids ? leadDetails.emi_scheme_ids : "";
  },

  setPerfiosTransactionType(perfiosTransactionType) {
    const loanScopeData = this.getLoanScopeData();
    loanScopeData.perfiosTransactionType = perfiosTransactionType;
    this.setLoanScopeData(loanScopeData);
  },

  getPerfiosTransactionType() {
    const loanScopeData = this.getLoanScopeData();
    return loanScopeData.perfiosTransactionType;
  },

  setParentLoanId(parentLoanId) {
    const loanScopeData = this.getLoanScopeData();
    loanScopeData.parentLoanId = parentLoanId;
    this.setLoanScopeData(loanScopeData);
  },

  getParentLoanId() {
    const loanScopeData = this.getLoanScopeData();
    return loanScopeData.parentLoanId;
  },

  setParentApplicantType(parentApplicantType) {
    const loanScopeData = this.getLoanScopeData();
    loanScopeData.parentApplicantType = parentApplicantType;
    this.setLoanScopeData(loanScopeData);
  },

  getParentApplicantType() {
    const loanScopeData = this.getLoanScopeData();
    return loanScopeData.parentApplicantType;
  },

  setAssociatedEntityType(associatedEntityType) {
    const loanScopeData = this.getLoanScopeData();
    loanScopeData.associatedEntityType = associatedEntityType;
    this.setLoanScopeData(loanScopeData);
  },

  getAssociatedEntityType() {
    const loanScopeData = this.getLoanScopeData();
    return loanScopeData.associatedEntityType;
  },

  setAssociatedEntityConfig(associatedEntityConfig) {
    const loanScopeData = this.getLoanScopeData();
    loanScopeData.associatedEntityConfig = associatedEntityConfig;
    this.setLoanScopeData(loanScopeData);
  },

  getAssociatedEntityConfig() {
    const loanScopeData = this.getLoanScopeData();
    return loanScopeData.associatedEntityConfig;
  }
};

